module.exports = __webpack_public_path__ + "static/media/completed-question-dot.ff8959a9.svg";